<div class="container-fluid">
  <div
    [ngClass]="{
      flow: !premium
    }"
  >
    <app-welcome-card
      [result]="resultGlobalStatistics.retainedConsumers"
      [loading$]="loadingGlobalStatics$ | async"
      [isStatisticsScreen]="true"
      [firstName]="userInfo?.firstName"
      [lastName]="userInfo?.lastName"
    ></app-welcome-card>
    <div
      class="d-flex mx-15"
      style="
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
      "
    >
      <h4>{{ "location.statistics.title" | translate }}</h4>
      <app-refresh-button
        [state]="fetchingCardsState"
        [date]="cachedAt"
        (buttonClick)="fetchCardsStatistics(true)"
      ></app-refresh-button>
    </div>
    <div class="row m-r-0">
      <div
        class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box-col-4 p-r-0"
      >
        <app-card
          [title]="impression.title"
          [icon]="impression.icon"
          [value]="resultGlobalStatistics.impressions"
          [class]="'eye'"
          [isLoading]="loadingGlobalStatics$ | async"
        >
        </app-card>
      </div>
      <div
        class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box-col-4 p-r-0"
      >
        <app-card
          [title]="consumers.title"
          [icon]="consumers.icon"
          [value]="resultGlobalStatistics.uniqueConsumers"
          [class]="'eye'"
          [isLoading]="loadingGlobalStatics$ | async"
          [infoTooltip]="'infoTooltip.uniqueConsumers' | translate"
        >
        </app-card>
      </div>
      <div
        class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box-col-4 p-r-0"
      >
        <app-card
          [title]="reach.title"
          [icon]="reach.icon"
          [value]="resultGlobalStatistics.reach"
          [class]="'eye'"
          [isLoading]="loadingGlobalStatics$ | async"
          [infoTooltip]="'infoTooltip.reach' | translate"
        >
        </app-card>
      </div>
      <app-audience
        class="p-r-0"
        [inputAudience$]="inputAudience"
        [isPremium]="premium"
        [startDate]="startDate"
        [endDate]="today"
      ></app-audience>
      <div class="card">
        <div class="card-header">
          <div class="media-space-between">
            <div class="d-flex m-t-15 align-items-center">
              <h4 class="m-0">
                {{ "location.statistics.retentionRate" | translate }}
              </h4>
              <app-info-tooltip-component
                style="padding-left: 4px"
                [infoTooltip]="'infoTooltip.retentionRate' | translate"
              ></app-info-tooltip-component>
            </div>
            <form
              [formGroup]="form"
              class="d-inline-flex col-10 col-xl-5 col-md-6 col-sm-8 col-xxl-4 justify-content-end"
            >
              <app-date-range-picker
                [form]="form | asFormGroup"
                inputFormControlName="date"
              ></app-date-range-picker>
              <app-export
                class="m-l-10"
                [buttonName]="'export'"
                [data]="retentionChart"
                [title]="title"
              ></app-export>
              <app-refresh-button
                class="m-l-10"
                [state]="fetchingCardsState"
                [date]="retentionRateCachedAt"
                (buttonClick)="fetchRetentionRate(true)"
              ></app-refresh-button>
            </form>
          </div>
          <div class="d-flex mx-15" style="justify-content: end"></div>
        </div>
        <div class="card-body" id="location.statistics.retentionRate">
          <app-column-chart
            [xaxisTitle]="columnChart.xaxisTitle"
            [yaxisTitle]="columnChart.yaxisTitle"
            [xaxisTitle]="columnChart.xaxisTitle"
            [resultRetentionRate]="retentionRate"
            [isLoading]="loadingRetentionRate$ | async"
          ></app-column-chart>
        </div>
      </div>
      <app-technical-data
        class="p-r-0"
        [search]="search"
        [isPremium]="premium"
      ></app-technical-data>
    </div>
  </div>
  <div class="centered" *ngIf="!premium">
    <img src="/assets/images/premium.png" style="width: 10%" alt="" />
    <h4 class="mt-3 f-w-600">
      {{ "location.statistics.premiumDescription" | translate }}
    </h4>
    <div class="mt-3">
      <a target="_blank" [href]="bookMeeting" class="btn btn-primary m-r-10">
        {{ "location.statistics.goPremium" | translate }}
      </a>
    </div>
  </div>
</div>
